import React from "react";
import { Stack, Typography } from "@mui/joy";
import Page from "../components/Pages/Page";
import PageHeader from "../components/PageHeader";
import { useOrgSettingsContext } from "../providers/OrgSettingsProvider";
import EmailIntegrationSettings from "../components/Organization/EmailIntegrationSettings";
import EmailLayoutSettings from "../components/Organization/EmailLayoutSettings";
import EmailTemplateManager from "../components/Organization/EmailTemplateManager";
import EmailUnsubscribeList from "../components/Organization/EmailUnsubscribeList";

const OrgSettingsEmail: React.FC = () => {
  const { user } = useOrgSettingsContext();

  return (
    <Page>
      <PageHeader>
        <Typography level="h1">Email</Typography>
        <Typography level="body-sm" color="neutral">
          Configure email integration, templates, and subscriber settings
        </Typography>
      </PageHeader>
      <Stack spacing={3}>
        <EmailIntegrationSettings organizationId={user.organization_id!} />
        <EmailLayoutSettings organizationId={user.organization_id!} />
        <EmailTemplateManager organizationId={user.organization_id!} />
        <EmailUnsubscribeList organizationId={user.organization_id!} />
      </Stack>
    </Page>
  );
};

export default OrgSettingsEmail;
